import styled from 'styled-components'
import { Dialog as MUIDialog } from '@mui/material'

export const StyledDialog = styled(MUIDialog)<{
  width: string | undefined,
  height: string | undefined,
  $minWidth: string | undefined
  $minHeight: string | undefined
  padding: string | undefined
}>`
  .MuiModal-backdrop {
    background-color: #000000B2 !important; // TODO: theme
  }

  .MuiDialog-paper {
    width: ${({ width }) => width};
    height: ${({ $minHeight, height }) => ($minHeight ? 'unset' : height)};
    min-width: ${({ $minWidth }) => $minWidth || 'unset'};
    min-height: ${({ $minHeight }) => $minHeight || 'unset'};
    max-width: 100%;
    background-color: ${({ theme }) => theme.colors.page.primary};
    box-shadow: ${({ theme }) => `0 0 1px 0 ${theme.colors.dim}, 0 1px 4px 0 ${theme.colors.dim}, 0 2px 8px 0 ${theme.colors.dim}`};
    padding: ${({ padding }) => padding};
    gap: 1rem;
  }

  .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
`
export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header__left {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  h5 {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  > button {
    position: absolute;
    right: 0.5rem;
  }
`

export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    min-width: 100%;
    max-height: 100%;
  }
`

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;

  &.button--large {
    justify-content: space-between;
    gap: 10px;
    > button {
      width: 50% !important;
    }
  }
`
